export type RewardDetailStockTone = 'available' | 'low' | 'sold-out'

export type RewardDetailModalInput = {
  name: string
  description?: string
  imageUrl?: string | null
  stockLabel?: string | null
  stockTone?: RewardDetailStockTone
  rewardType?: 'credit' | 'item'
  stock?: number
}

export function resolveRewardDetailStock(
  input: Pick<RewardDetailModalInput, 'rewardType' | 'stock' | 'stockLabel' | 'stockTone'>
): { label: string | null; tone: RewardDetailStockTone } {
  if (input.stockLabel) {
    const tone = input.stockTone || 'available'
    if (input.rewardType === 'item') {
      const match = input.stockLabel.match(/เหลือ\s+([\d,]+)/)
      if (match) {
        return { label: `เหลือสินค้า ${match[1]} ชิ้น`, tone }
      }
      if (input.stockLabel.includes('หมด')) {
        return { label: 'สินค้าหมดแล้ว', tone: 'sold-out' }
      }
    }
    return { label: input.stockLabel, tone }
  }

  const stock = Number(input.stock)
  if (!Number.isFinite(stock) || stock < 0) {
    return { label: null, tone: 'available' }
  }

  const unit = input.rewardType === 'item' ? 'ชิ้น' : 'สิทธิ์'
  const label =
    input.rewardType === 'item'
      ? `เหลือสินค้า ${stock.toLocaleString('th-TH')} ชิ้น`
      : `เหลือ ${stock.toLocaleString('th-TH')} ${unit}`

  return {
    label,
    tone: stock <= 0 ? 'sold-out' : stock <= 3 ? 'low' : 'available',
  }
}

export function buildRewardDetailModalHtml(
  reward: RewardDetailModalInput,
  escapeHtml: (value: string) => string
): string {
  const description = String(reward.description || '').trim()
  if (!description) return ''

  const imageUrl = String(reward.imageUrl || '').trim()
  const stock = resolveRewardDetailStock(reward)

  const mediaHtml = imageUrl
    ? `<div class="huay-reward-detail-media">
        <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(reward.name)}" class="huay-reward-detail-image" loading="lazy">
      </div>`
    : `<div class="huay-reward-detail-fallback" aria-hidden="true">
        <i class="fas fa-gift"></i>
      </div>`

  const stockHtml = stock.label
    ? `<span class="huay-reward-detail-stock-badge huay-reward-detail-stock-badge--${stock.tone}">${escapeHtml(stock.label)}</span>`
    : ''

  return `
    <div class="huay-reward-detail-body">
      ${mediaHtml}
      <div class="huay-reward-detail-head">
        <p class="huay-reward-detail-title">${escapeHtml(reward.name)}</p>
        ${stockHtml}
      </div>
      <p class="huay-reward-detail-text">${escapeHtml(description).replace(/\n/g, '<br>')}</p>
    </div>
  `
}
